import React from 'react'

import { createValidIcon } from '@ui/icons/utils/type-helper'

export const CheckIcon = createValidIcon((props) => {
  const { size, color } = props

  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={size}
      height={size}
      viewBox='0 0 24 24'
      fill='none'
    >
      <path
        d='M18.0198 7.05005C18.4103 6.65964 19.0443 6.65959 19.4348 7.05005C19.8249 7.44046 19.8249 8.07364 19.4348 8.46411L10.9504 16.9495C10.7629 17.137 10.5076 17.2424 10.2424 17.2424C9.97738 17.2423 9.72283 17.1369 9.5354 16.9495L5.29321 12.7073C4.90269 12.3168 4.90269 11.6828 5.29321 11.2922C5.68369 10.9022 6.31686 10.9021 6.70728 11.2922L10.2424 14.8274L18.0198 7.05005Z'
        fill={color}
      />
    </svg>
  )
})
